import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { ROUTES } from '../../utils/Routes';
import styles from '../../styles/Footer.module.css';


const Footer: React.FC = () => {
    const projects = [
        { id: 1, image: '/images/Footer/project-1.jpg', title: 'Project 1' },
        { id: 2, image: '/images/Footer/project-2.jpg', title: 'Project 2' },
        { id: 3, image: '/images/Footer/project-3.jpg', title: 'Project 3' },
        { id: 4, image: '/images/Footer/project-4.jpg', title: 'Project 4' },
        { id: 5, image: '/images/Footer/project-5.jpg', title: 'Project 5' },
        { id: 6, image: '/images/Footer/project-6.jpg', title: 'Project 6' },
    ];

    return (
        <>
            <footer className={styles.mainFooter}>
                <Container>
                    <Row>
                        {/* Company Info Column */}
                        <Col lg={3} md={6} className="mb-4">
                            <div className={styles.footerLogo}>
                                <img src="/images/logo.svg" alt="Symbioun Logo" className={styles.footerLogoImg} />
                            </div>
                            <p className={styles.footerDescription}>
                                At Symbioun, we believe sustainable growth hinges on factors beyond simple resource availability
                            </p>
                            <div className={styles.footerSocialIcons}>
                                <a href="/" className={styles.socialIconLink}>
                                    <div className={styles.socialIconCircle}>
                                        <img src="/icons/facebook.svg" alt="Facebook" />
                                    </div>
                                </a>
                                <a href="/" className={styles.socialIconLink}>
                                    <div className={styles.socialIconCircle}>
                                        <img src="/icons/twitter.svg" alt="Twitter" />
                                    </div>
                                </a>
                                <a href="/" className={styles.socialIconLink}>
                                    <div className={styles.socialIconCircle}>
                                        <img src="/icons/instagram.svg" alt="Instagram" />
                                    </div>
                                </a>
                                <a href="/" className={styles.socialIconLink}>
                                    <div className={styles.socialIconCircle}>
                                        <img src="/icons/gmail.svg" alt="Google" />
                                    </div>
                                </a>
                            </div>
                        </Col>

                        {/* Quick Links Column */}
                        <Col lg={3} md={6} className="mb-4">
                            <h5 className={styles.footerHeading}>Quick Links</h5>
                            <Nav className={`flex-column ${styles.footerLinks}`}>
                                <Nav.Link href={ROUTES.ABOUTUS_ROUTE} className={styles.footerLink}><img src="/icons/rightArrow.svg" alt="arrow" />About Company</Nav.Link>
                                <Nav.Link href={ROUTES.SERVICE_ROUTE} className={styles.footerLink}><img src="/icons/rightArrow.svg" alt="arrow" />Our Services</Nav.Link>
                                <Nav.Link href={`${ROUTES.SERVICE_ROUTE}/business-consultation`} className={styles.footerLink}><img src="/icons/rightArrow.svg" alt="arrow" />Business Consultation</Nav.Link>
                                <Nav.Link href={`${ROUTES.SERVICE_ROUTE}/start-up-funding`} className={styles.footerLink}><img src="/icons/rightArrow.svg" alt="arrow" />Start-up Funding</Nav.Link>
                                <Nav.Link href={`${ROUTES.SERVICE_ROUTE}/community-empowerment`} className={styles.footerLink}><img src="/icons/rightArrow.svg" alt="arrow" />Community Empowerment</Nav.Link>
                                <Nav.Link href={`${ROUTES.SERVICE_ROUTE}/esg-csr-project`} className={styles.footerLink}><img src="/icons/rightArrow.svg" alt="arrow" />ESG/CSR Project Management</Nav.Link>
                            </Nav>
                        </Col>

                        {/* Location Column */}
                        <Col lg={3} md={6} className="mb-4">
                            <h5 className={styles.footerHeading}>Head Office</h5>
                            <div className={styles.locationInfo}>
                                <div className={styles.locationCircle}>
                                    <img src="/icons/location.svg" alt="location" />
                                </div>
                                <p>Rev Fr Mariyanayagam Centre, RDS Road, Mavadivembu, Batticaloa, Sri Lanka</p>
                            </div>
                            <h6 className={styles.footerHeading}>Email</h6>
                            <div className={styles.locationInfo}>
                                <div className={styles.locationCircle}>
                                    <img src="/icons/location.svg" alt="location" />
                                </div><p>info@symbioun.lk</p>
                            </div>
                        </Col>

                        {/* Projects Column */}
                        <Col lg={3} md={6} className="mb-4">
                            <h5 className={styles.footerHeading}>Projects</h5>
                            <div className={styles.projectsGrid}>
                                {projects.map((project) => (
                                    <div key={project.id} className={styles.projectItem}>
                                        <img src={project.image} alt={project.title} className={styles.projectImage} />
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>

            {/* Copyright Footer */}
            <footer className={styles.copyrightFooter}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <p className={styles.copyrightText}>
                                &copy; {new Date().getFullYear()} Symbioun | All rights reserved by Symbioun.
                            </p>
                        </Col> 
                        <Col lg={6} className='text-end'>
                            <p>
                                <a href={ROUTES.TERMS_CONDITIONS_ROUTE} className={styles.footerPolicyLink}>Terms & Conditions</a>
                                <span className={`${styles.pipeStyle} mx-2`}>|</span>
                                <a href={ROUTES.PRIVACY_POLICY_ROUTE} className={styles.footerPolicyLink}>Privacy Policy</a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    );
};

export default Footer; 